import React from 'react'

export const UserContext = React.createContext(null)
export const ProReferenceContext = React.createContext(null)
